import styled from 'styled-components';
import { colors } from "colors";

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
`;

export const WorkOrderStatusWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  
  :not(:first-child) {
    margin-left: -4%;
  }

  span {
    margin-top: 8px;
    font-weight: bold;
    font-size: 14px;
    color: ${colors.slateGrey};
  }
  
  &[data-active="true"] span {
    color: ${colors.brightBlue};
  }
  
  svg {
    width: 100%;
    height: auto;
  }
  
  &[data-active="true"] svg {
    #inner-background {
      fill: ${colors.brightBlue};
    }
    
    #arrow-border {
      stroke: ${colors.brightBlue};
    }
  }
`;
